import ManualTradeTableCloseOrderConfirmation from './ManualTradeTableCloseOrderConfirmation';

export default ManualTradeTableCloseOrderConfirmation;
